import { useDispatch } from "react-redux";
import CreateRoutes from "./routes";
import { useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { BannerProvider } from "./providers/BannerProviders";
import { useContext, useEffect, useState } from "react";
import { verifyAuth } from "./redux/slice/authSlice";
import { useSelector } from "react-redux";
import SocketContext, { useSocket } from "./providers/SocketContext";
import LoadingFallback from "./components/elements/LoadingFallback";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getTheme } from "./redux/slice/themeSlice";
import ThemeConfig from "./config/ThemeConfig";
import { ThemeProvider, useTheme } from "./providers/ThemeProvider";

function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);
  // const { theme } = useSelector((state) => state?.themeProvider);
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    dispatch(getTheme());
  }, []);

  useEffect(() => {
    const authProvider = window.localStorage.getItem("auth_provider");
    if (authProvider === "keycloak") {
      return;
    }
    dispatch(verifyAuth());
  }, [location.pathname, session?.status]);

  useEffect(() => {
    if (socket?.connected && session?.user?._id) {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket?.connected, session?.user?._id]);

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <>
      {/* <ThemeConfig /> */}
      <ThemeProvider>
      <HelmetProvider>
        <BannerProvider>
          <CreateRoutes />
        </BannerProvider>
      </HelmetProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
